import FactoryModel, { initialFactory } from '../../models/factory';
import TaxModel from '../../models/tax';
import VendorModel from '../../models/vendor';
import ShippingModel from '../../models/shipping';
import StoreModel from '../../models/store';
import DiscountModel from '../../models/discount';
import CommRuleModel from '../../models/commRule';
import RegionModel from '../../models/region';
import BankModel from '../../models/bank';
import TermModel from '../../models/term';
import CommPeriodModel from '../../models/commPeriod';
import CommPayModel from '../../models/commPay';

export const FACTORY_FAILURE = 'FACTORY_FAILURE';
export const FETCH_FACTORIES_SUCCESS = 'FETCH_FACTORIES_SUCCESS';
export const FETCH_MY_FACTORY_SUCCESS = 'FETCH_MY_FACTORY_SUCCESS';
export const FETCH_FACTORY_SUCCESS = 'FETCH_FACTORY_SUCCESS';
export const CREATE_FACTORY_SUCCESS = 'SAVE_FACTORY_SUCCESS';
export const UPDATE_FACTORY_SUCCESS = 'SAVE_FACTORY_SUCCESS';
export const UPDATE_FACTORY_SETTING_SUCCESS = 'UPDATE_FACTORY_SETTING_SUCCESS';
export const DELETE_FACTORY_SUCCESS = 'DELETE_FACTORY_SUCCESS';
export const CLEAN_FACTORY = 'CLEAN_FACTORY';
export const FETCH_PERIODS_SUCCESS = 'FETCH_PERIODS_SUCCESS';
export const FETCH_COMMPAY_SUCCESS = 'FETCH_COMMPAY_SUCCESS';
export const FETCH_STORE_SUCCESS = 'FETCH_STORE_SUCCESS';
export const FETCH_TAXES_SUCCESS = 'FETCH_TAXES_SUCCESS';
export const FETCH_TERMS_SUCCESS = 'FETCH_TERMS_SUCCESS';
export const FETCH_VENDORS_SUCCESS = 'FETCH_VENDORS_SUCCESS';
export const FETCH_SHIPPINGS_SUCCESS = 'FETCH_SHIPPINGS_SUCCESS';
export const FETCH_DISCOUNTS_SUCCESS = 'FETCH_DISCOUNTS_SUCCESS';
export const FETCH_COMMRULES_SUCCESS = 'FETCH_COMMRULES_SUCCESS';
export const FETCH_REGIONS_SUCCESS = 'FETCH_REGIONS_SUCCESS';
export const FETCH_BANKS_SUCCESS = 'FETCH_BANKS_SUCCESS';
export const RESET_FINISHED = 'FACTORY_RESET_FINISHED';

// Action Types
export interface typeOnlyType {
  type:
    | typeof CREATE_FACTORY_SUCCESS
    | typeof UPDATE_FACTORY_SUCCESS
    | typeof CLEAN_FACTORY
    | typeof DELETE_FACTORY_SUCCESS
    | typeof RESET_FINISHED;
}

export interface failureType {
  type: typeof FACTORY_FAILURE;
  err: string;
}

export interface FetchFactorySuccessType {
  type: typeof FETCH_FACTORY_SUCCESS;
  factory: FactoryModel;
}

export interface FetchFactoriesSuccessType {
  type: typeof FETCH_FACTORIES_SUCCESS;
  factories: Array<FactoryModel>;
}

export interface FetchPeriodsSuccessType {
  type: typeof FETCH_PERIODS_SUCCESS;
  periods: Array<CommPeriodModel>;
}

export interface FetchCommPaySuccessType {
  type: typeof FETCH_COMMPAY_SUCCESS;
  commPay: CommPayModel;
}

export interface FetchMyFactorySuccessType {
  type: typeof FETCH_MY_FACTORY_SUCCESS;
  factory: FactoryModel;
}

export interface UpdateFactorySettingType {
  type: typeof UPDATE_FACTORY_SETTING_SUCCESS;
  settings: any;
}

export interface FetchStoreSuccessType {
  type: typeof FETCH_STORE_SUCCESS;
  store: StoreModel;
}

export interface FetchTaxesSuccessType {
  type: typeof FETCH_TAXES_SUCCESS;
  taxes: Array<TaxModel>;
}

export interface FetchVendorsSuccessType {
  type: typeof FETCH_VENDORS_SUCCESS;
  vendors: Array<VendorModel>;
}

export interface FetchRegionsSuccessType {
  type: typeof FETCH_REGIONS_SUCCESS;
  regions: Array<RegionModel>;
}

export interface FetchShippingsSuccessType {
  type: typeof FETCH_SHIPPINGS_SUCCESS;
  shippings: Array<ShippingModel>;
}

export interface FetchCommRulesSuccessType {
  type: typeof FETCH_COMMRULES_SUCCESS;
  commRules: Array<CommRuleModel>;
}

export interface FetchDiscountsSuccessType {
  type: typeof FETCH_DISCOUNTS_SUCCESS;
  discounts: Array<DiscountModel>;
}

export interface FetchBanksSuccessType {
  type: typeof FETCH_BANKS_SUCCESS;
  banks: Array<BankModel>;
}

export interface FetchTermsSuccessType {
  type: typeof FETCH_TERMS_SUCCESS;
  terms: Array<TermModel>;
}

export interface FactoryReducerType {
  factory: FactoryModel;
  factories?: Array<FactoryModel>;
  periods?: Array<CommPeriodModel>;
  commPay?: CommPayModel;
  store: StoreModel | null;
  isFinished: boolean;
  refresh: boolean;
  hisFactory: FactoryModel | null;
}

export type FactoryActionTypes =
  | typeOnlyType
  | failureType
  | FetchFactorySuccessType
  | FetchMyFactorySuccessType
  | FetchStoreSuccessType
  | FetchTaxesSuccessType
  | FetchShippingsSuccessType
  | FetchFactoriesSuccessType
  | FetchDiscountsSuccessType
  | FetchCommRulesSuccessType
  | FetchRegionsSuccessType
  | FetchBanksSuccessType
  | FetchTermsSuccessType
  | FetchPeriodsSuccessType
  | FetchCommPaySuccessType
  | UpdateFactorySettingType
  | FetchVendorsSuccessType;

export const FACTORY_INIT_STATE: FactoryReducerType = {
  factory: initialFactory,
  store: null,
  isFinished: false,
  refresh: true,
  hisFactory: null,
};
